module.exports = __webpack_public_path__ + "static/img/6.fc4a94e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news17/6.png
// module id = pvav
// module chunks = 1